// src/utils/durationFormat.js
// Human-readable Neo duration formatting.
// Examples: 38M, 4H 12M, 2D 6H 50M.

export function formatDurationMinutes(value, { zero = "0M" } = {}) {
  const total = Math.max(0, Math.round(Number(value || 0)));
  if (!Number.isFinite(total) || total <= 0) return zero;

  const days = Math.floor(total / 1440);
  const hours = Math.floor((total % 1440) / 60);
  const minutes = total % 60;

  const parts = [];
  if (days) parts.push(`${days}D`);
  if (hours) parts.push(`${hours}H`);
  if (minutes || !parts.length) parts.push(`${minutes}M`);
  return parts.join(" ");
}

export function formatDurationSeconds(value, { zero = "0M 00S" } = {}) {
  const totalSeconds = Math.max(0, Math.floor(Number(value || 0)));
  if (!Number.isFinite(totalSeconds) || totalSeconds <= 0) return zero;

  const totalMinutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  if (totalMinutes >= 60) {
    return formatDurationMinutes(totalMinutes);
  }

  return `${totalMinutes}M ${String(seconds).padStart(2, "0")}S`;
}
